
<template>
    <div class="row" style="margin-left: 0px; margin-right: 0px;">

            <div class="input-group green_line" v-for="n in formulaire.next" :key="n.id" > 
                <div class="col-md-1 ml-sm-0 col-lg-1 pt-1 px-1" >
                    <span class="glyphicon glyphicon-arrow-right" id="basic-addon3" ></span>
                </div>

                <div class="col-md-11 ml-sm-0 col-lg-11 pt-1 px-1">

                    <div class="row mx-0 py-3">
                        <h6 v-if='n.type=="Question"' style="margin-bottom: 0px;">{{n.intitule}}</h6> <!--Question-->
                    </div>
                        <!-- Single button -->
                    <div class ="row mx-0" v-for="o in n.next" :key="o.id">
                        
                        <div class="col-md-11 ml-sm-0 col-lg-11 pt-1 px-1">
                            <div class ="row mx-0 buttonOriginal2"> 
                                <input type="radio" class ="buttonOriginal3 mx-3 my-3" :id="o.intitule" :name="n.intitule" :value="o.intitule"  v-model="n.selection" >
                                <h5 class="my-0 py-3" :for="o.intitule">{{o.intitule}}</h5>
                            </div>
                            <div class="row mx-0" v-if="n.selection==o.intitule && o.next.length>0">
                                <div class="col-md-1 ml-sm-0 col-lg-1 pt-1 px-1" >
                                    <span class="glyphicon glyphicon-arrow-right" id="basic-addon3" ></span>
                                </div>

                            <div class="col-md-11 ml-sm-0 col-lg-11 pt-1 px-1"> 
                                <div v-for="p in o.next" :key="p.id">

                                    <div class="row mx-0 py-3 " >
                                        <h6 v-if='p.type=="Question"' style="margin-bottom: 0px;">{{p.intitule}}</h6> <!--Question-->
                                    </div>
                                    <div class ="row mx-0 " v-for="q in p.next" :key="q.id">
                                        <div class="col-md-11 ml-sm-0 col-lg-11 pt-1 px-1">
                                        <div class ="row mx-0 buttonOriginal2"> 
                                            <input type="radio" class =" buttonOriginal3 mx-3 my-3" :id="q.intitule"  :value="q.intitule"  v-model="p.selection" >
                                
                                            <h5 class="my-0 py-3" :for="q.intitule">{{q.intitule}}</h5>
                                        </div>
                                        <div class="row mx-0" v-if="p.selection==q.intitule && q.next.length>0">
                                            <div class="col-md-1 ml-sm-0 col-lg-1 pt-1 px-1" >
                                                <span class="glyphicon glyphicon-arrow-right" id="basic-addon3" ></span>
                                            </div>
                                            <div class="col-md-11 ml-sm-0 col-lg-11 pt-1 px-1">
                                            <div v-for="r in q.next" :key="r.id">

                                                <div class="col-md-1 ml-sm-0 col-lg-11 pt-1 px-1">
                                                    <span class="glyphicon glyphicon-arrow-right" id="basic-addon3" ></span>
                                                </div>
                                            
                                                <div class="col-md-11 ml-sm-0 col-lg-11 pt-1 px-1">


                                                    <div class="row form-inline" style="margin-left: 0px; margin-right: 0px;">
                                                        <h6 v-if='r.type=="Question"' style="margin-bottom: 0px;">{{r.intitule}}</h6> <!--Question-->
                                                    </div>
                                                    <div class ="row mx-0 " v-for="s in r.next" :key="s.id">
                                                        <div class="col-md-11 ml-sm-0 col-lg-11 pt-1 px-1">
                                                        <div class ="row mx-0 buttonOriginal2"> 
                                                            <input type="radio" class =" buttonOriginal3 mx-3 my-3" :id="s.intitule"  :value="s.intitule"  v-model="r.selection" >
                                                
                                                            <h5 class="my-0 py-3" :for="s.intitule">{{s.intitule}}</h5>
                                                        </div>
                                                        </div>
                                                    </div>

                                                    <div v-for="s in r.next" :key="s.id">
                                                        <div class="row form-inline" v-if="r.selection==s.intitule && s.next.length>0">

                                                            <div class="col-md-1 ml-sm-0 col-lg-11 pt-1 px-1">
                                                                <span class="glyphicon glyphicon-arrow-right" id="basic-addon3" ></span>
                                                            </div>
                                                            
                                                            <div class="col-md-11 ml-sm-0 col-lg-11 pt-1 px-1">

                                                                <div v-for= "t in s.next" :key="t.id">

                                                                    <div class="row form-inline" style="margin-left: 0px; margin-right: 0px;">
                                                                        <h6 v-if='t.type=="Question"' style="margin-bottom: 0px;">{{t.intitule}}</h6> <!--Question-->
                                                                    </div>
                                                                    <select v-model ="t.selection" class="btn btn-default dropdown-toggle">
                                                                        <option v-for= "u in t.next" :key="u.id">{{u.intitule}}</option>
                                                                    </select>

                                                                </div>

                                                            </div>

                                                        </div>
                                                    </div>
                                                
                                        </div>
                                        </div>
                                    </div>
                                    </div>
                                </div>
                                </div>
                                </div>
                            </div>
                        </div>
                        </div>
                    </div>
                </div>


            </div>
        <div class="col-md-6 ml-sm-0 col-lg-6 pt-1 px-1">
            <div class="row form-inline" style="margin-left: 0px; margin-right: 0px;">
                <input name="formulaire" type="hidden" id="formulaire" style="visibility:hidden" >
                <button type="button" class="buttonOriginal" aria-label="Left Align" v-on:click='save()' :title="trans.get('common.save')">
                    <span class="glyphicon glyphicon-floppy-save" aria-hidden="true"></span>
                </button>
                <button type="button" class="buttonOriginal" aria-label="Left Align" v-on:click='back()' :title="trans.get('common.cancel')">
                    <span class="glyphicon glyphicon-remove" aria-hidden="true"></span>
                </button>
            </div>
        </div>
    
        <div v-if="showModal" class="modal" id="myModal" role="dialog">
            <div class="modal-dialog">
            
                <div class="modal-content  text-blue_claire dark-panel" >
                    <div class="modal-header">
                        <h4 class="modal-title">{{trans.get('common.alert')}}</h4>
                        <button type="button" class="close" data-dismiss="modal" @click="closeModal">&times;</button>
                    </div>
                    <div class="modal-body">
                        <p>{{trans.get('common.please_answer_all_questions')}}</p>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-default text-blue_claire" data-dismiss="modal" @click="closeModal">{{trans.get('common.ok')}}</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script >

    export default {
        props : ['questionnaire', 'building', 'nameproject'],     
        data : function(){
            return {
                formulaire:{
                    next :[ {
                        id :0,
                        type:"Question",
                        intitule : "",
                        next : [],
                        selection: "",
                    }],
                },

                reponse:{
                    next:[{
                        idr:0,
                        type:"Question",
                        intitule:"",
                        next:{},
                    }],
                },

                id:1,
                idr:1,
                showModal: false,
            };
        },
        mounted: function(){
            //this.formulaire = JSON.parse(this.questionnaire.building);
            this.formulaire = this.questionnaire;

        },
        methods :{
            validateAllQuestions() {
                var data = this.formulaire.next;
                var isOk = true;
                for(var item of data) {
                    isOk &= this.validateQuestionIsFilled(item);
                }
                return isOk;
            },
            validateQuestionIsFilled(item) {
                if(item.type == "Question") {
                    if(item.selection == undefined || item.selection == "") {
                        return false;
                    }
                }
                if(item.next != undefined && Array.isArray(item.next) && item.next.length > 0) {
                    var subitems = item.next;
                    var subitemsAreFilled = true;
                    for(var subitem of subitems) {
                        if(subitem.intitule == item.selection || item.type=="Reponse") {
                            subitemsAreFilled &= this.validateQuestionIsFilled(subitem);
                        }
                    }
                    return subitemsAreFilled;
                }
                return true;
            },
            save(){
                var isFilled = this.validateAllQuestions();
                if(isFilled) {
                    var data = JSON.stringify(this.formulaire);
                    document.getElementById("formulaire").value=data;
                    document.getElementById("submitquestionnaire").submit();
                } else {
                    this.showModal = true;
                }
                
            },
            closeModal(){
                this.showModal = false;
            },
            choose(id, parent){
               
               parent.next.forEach(element => {
                   document.getElementById(element.intitule).checked=false;
               })
            
               document.getElementById(id).checked=true;
               
            },
            back(){
                 document.getElementById("back").submit();
                
            },
            
        },
    }

</script>
